// extracted by mini-css-extract-plugin
module.exports = {"fields":"file-notes_fields__1MOW5","notes":"file-notes_notes__1prwO"};